export default __webpack_public_path__ + "static/media/EsagonoPattern.74e5b598.png";